/**
 * OAuth Tradovate LIÉ à la session (audit sécurité 2026-10-22, H2).
 *
 * Avant : le callback public créait la connexion pour l'utilisateur nommé par
 * le `state`, quel que soit le navigateur qui revenait. Un attaquant pouvait
 * donc faire autoriser SON lien par une victime et recevoir le jeton de
 * celle-ci. Avec la liaison, le callback ne crée plus rien : il renvoie un
 * ticket chiffré au SPA, et c'est une action AUTHENTIFIÉE qui termine, à
 * condition que l'utilisateur connecté soit celui du `state`.
 *
 * Piloté par TRADOVATE_OAUTH_BOUND_USERS, sur le modèle de LITE_MODE_USERS :
 *   - absente ou vide : personne, parcours historique inchangé ;
 *   - emails séparés par des virgules : ces utilisateurs seulement ;
 *   - `*` : tout le monde.
 * Le drapeau est décidé au DÉMARRAGE du flux (pour l'utilisateur qui le
 * lance) et porté par le `state` signé. La faille n'est donc fermée pour tous
 * qu'avec `*`.
 *
 * Module pur : chargeable sous vitest.
 */
export const ALL_BOUND_USERS = "*";

export function readBoundUsers(raw: string | undefined): string[] {
  return (raw ?? "")
    .split(",")
    .map((s) => s.trim().toLowerCase())
    .filter(Boolean);
}

export function isOAuthBindingEnabledFor(
  email: string | null | undefined,
  raw: string | undefined = process.env.TRADOVATE_OAUTH_BOUND_USERS,
): boolean {
  const users = readBoundUsers(raw);
  if (users.includes(ALL_BOUND_USERS)) return true;
  const normalized = email?.trim().toLowerCase();
  return !!normalized && users.includes(normalized);
}

/** Paramètre d'URL qui porte le ticket du callback vers le SPA. */
export const COMPLETE_PARAM = "tradovateComplete";

/** Contenu du ticket : le code d'autorisation et le state, tels que reçus. */
export interface CompletionTicket {
  code: string;
  state: string;
}

export function serializeTicket(ticket: CompletionTicket): string {
  return JSON.stringify({ c: ticket.code, s: ticket.state });
}

export function parseTicket(json: string): CompletionTicket | null {
  try {
    const raw = JSON.parse(json);
    if (typeof raw?.c !== "string" || typeof raw?.s !== "string") return null;
    if (!raw.c || !raw.s) return null;
    return { code: raw.c, state: raw.s };
  } catch {
    return null;
  }
}
